import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedAgency:   null,
    selectedCampaign: null,
    isEditingAgency:   false,
    isEditingCampaign: false,
    activeTab:        "campaigns",  // "campaigns" | "agencies" | "points"
};

const adMarketplaceSlice = createSlice({
    name: "adMarketplace",
    initialState,
    reducers: {
        setSelectedAgency:    (state, { payload }) => { state.selectedAgency   = payload; },
        setSelectedCampaign:  (state, { payload }) => { state.selectedCampaign = payload; },
        setIsEditingAgency:   (state, { payload }) => { state.isEditingAgency   = payload; },
        setIsEditingCampaign: (state, { payload }) => { state.isEditingCampaign = payload; },
        setActiveTab:         (state, { payload }) => { state.activeTab         = payload; },
        resetAdMarketplace:   () => initialState,
    },
});

export const {
    setSelectedAgency, setSelectedCampaign,
    setIsEditingAgency, setIsEditingCampaign,
    setActiveTab, resetAdMarketplace,
} = adMarketplaceSlice.actions;

export default adMarketplaceSlice.reducer;
